import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { addLocation } from 'shared/src/utils/addNavigate'
import { addAuthContext } from 'shared/src/utils/auth'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { addShowRegisterContext } from 'utils/register'
import { sansSerifFontFamily } from '../../utils/styles'
import { ColorButton } from '../ColorButton'
import { TextButton } from '../TextButton'

const useStyles = createUseStyles({
  section: {
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'stretch',
  },
  registerButton: {
    marginBottom: 32,
  },
  signinText: {
    color: 'rgba(255, 255, 255, 0.72)',
    fontFamily: sansSerifFontFamily,
    fontSize: 12,
    lineHeight: '140%',
    fontStyle: 'normal',
    alignSelf: 'center',
  },
})

export const LoginSection: FC = flowMax(
  addDisplayName('RegisterSection'),
  addLocation,
  addShowRegisterContext,
  addAuthContext,
  addHandlers({
    onClickLogin:
      ({ loginTrigger, navigateToLogin, setShowRegister }) =>
      () => {
        setShowRegister(false)
        navigateToLogin({ loginTrigger })
      },
    onClickRegister:
      ({ navigateToRegister, setShowRegister }) =>
      () => {
        setShowRegister(false)
        navigateToRegister({})
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ onClickLogin, onClickRegister, t, classes }) => (
    <div className={classes.section}>
      <ColorButton
        backgroundColor="#CEAF85"
        textColor="#FFFFFF"
        onClick={onClickLogin}
        title={t('auth.login.button')}
        className={classes.registerButton}
      />
      <span className={classes.signinText}>
        {t('auth.login.noAccount')}{' '}
        <TextButton onClick={onClickRegister} text={t('auth.login.register')} />
      </span>
    </div>
  )
)
